/**
 * Removed templated families (owner decision 2026-09-23): city x tool, rashi
 * pairs, monthly vrat occurrences, sign x year horoscopes, graha/nakshatra/yoga/
 * antardasha leaves and per-nakshatra baby names. 120 days of first-touch
 * attribution put 0 of 303 purchases, 0 of 5,342 checkouts and 0 of ~67.7k
 * leads on any of them. Each path answers HTTP 410 Gone from every serving
 * layer, with a noindex body that links the family hub. Never add a templated
 * family again.
 *
 * The 2026-09-30 cleanup release added the retired /explain/ family, the four
 * past 2026 eclipses and the Shopify leftovers without an equivalent page.
 *
 * This table and crawl-policy-data.json are URL disposition config, judged on
 * their merits by the SEO policy (Rule 3: honest retirement). There is no
 * change freeze (owner decision 2026-10-25; Notion SEO policy, Rule 17).
 *
 * One compact rule per family lives in crawl-policy-data.json
 * (`gonePathPatterns`), so the app middleware, both content Workers, the static
 * exporter and every sitemap read the same table. `gonePathExemptPaths` keeps
 * the 51 hand-rewritten Hindi pages (D1 `generated_by =
 * 'manual_hindi_rewrite_2026_09_23'`) that sit inside a removed family, and
 * the five hand-built English yoga guides (YOGA_GUIDE_SLUGS).
 * `pathDisposition` resolves a governed 301 before this, so a genuine one-to-one
 * redirect always wins over a family rule.
 *
 * Dependency-free with explicit extensions: the static exporter imports it under
 * bare Node (rule 64), exactly like internal-href-canonical.ts.
 */

import crawlPolicyData from "../../src/data/crawl-policy-data.json" with { type: "json" };

const GONE_PATTERNS = crawlPolicyData.gonePathPatterns.map((entry) => ({
  pattern: new RegExp(entry.pattern),
  hub: entry.hub,
}));
const GONE_EXEMPT_PATHS = new Set<string>(crawlPolicyData.gonePathExemptPaths);

function withTrailingSlash(pathname: string): string {
  if (pathname === "/") return "/";
  if ((pathname.split("/").pop() ?? "").includes(".")) return pathname;
  return pathname.endsWith("/") ? pathname : `${pathname}/`;
}

/** The family hub a removed path points readers to, or null when the path is not removed. */
export function goneFamilyHubPath(pathname: string): string | null {
  const normalized = withTrailingSlash(pathname);
  if (GONE_EXEMPT_PATHS.has(normalized)) return null;
  for (const { pattern, hub } of GONE_PATTERNS) {
    const match = pattern.exec(normalized);
    if (match) return hub.replace(/\$(\d)/g, (_, index) => match[Number(index)] ?? "");
  }
  return null;
}

export function isGonePath(pathname: string): boolean {
  return goneFamilyHubPath(pathname) !== null;
}
